<template>
  <header class="header">
    <div class="header-inner">
      <!-- Logo -->
      <router-link :to="{ name: 'Calendar', params: { slug } }" class="logo">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <rect x="3" y="4" width="18" height="16" rx="2"/>
          <path d="M3 9h18M9 4v5M15 4v5"/>
        </svg>
        Tempahan Bilik
      </router-link>

      <!-- Nav -->
      <nav class="nav">
        <router-link :to="{ name: 'Calendar',   params: { slug } }" class="nav-link">Calendar</router-link>
        <router-link :to="{ name: 'MyBookings',  params: { slug } }" class="nav-link">My Bookings</router-link>
        <router-link v-if="auth.isAdmin" :to="{ name: 'Admin', params: { slug } }" class="nav-link">Admin</router-link>
      </nav>

      <!-- User area -->
      <div class="user-area">
        <div class="avatar-wrap">
          <img
            v-if="auth.user?.picture && !pictureBroken"
            :src="auth.user.picture"
            :alt="auth.user.name"
            class="avatar"
            referrerpolicy="no-referrer"
            @error="pictureBroken = true"
          />
          <div v-else class="avatar-fallback">{{ userInitials }}</div>
        </div>
        <span class="user-name">{{ auth.user?.name }}</span>
        <span v-if="auth.isAdmin" class="badge badge-admin">Admin</span>
        <button class="btn btn-ghost btn-sm" @click="handleSignOut">Sign out</button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAuthStore }   from '@/stores/auth'
import { useTenantStore } from '@/stores/tenant'
import { useRouter, useRoute } from 'vue-router'

const auth   = useAuthStore()
const tenant = useTenantStore()
const router = useRouter()
const route  = useRoute()
const slug   = computed(() => route.params.slug || tenant.slug)

const pictureBroken = ref(false)

const userInitials = computed(() =>
  (auth.user?.name || '')
    .split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
)

function handleSignOut () {
  auth.signOut(slug.value)
  router.push({ name: 'Login', params: { slug: slug.value } })
}
</script>

<style scoped>
.header {
  height: var(--header-h);
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  position: sticky; top: 0; z-index: 100;
}
.header-inner {
  max-width: 1600px; margin: 0 auto;
  height: 100%;
  display: flex; align-items: center; gap: 24px;
  padding: 0 24px;
}
.logo {
  display: flex; align-items: center; gap: 8px;
  font-weight: 700; font-size: 16px; color: var(--primary);
  white-space: nowrap; text-decoration: none;
}
.nav { display: flex; align-items: center; gap: 4px; }
.nav-link {
  padding: 6px 12px; border-radius: 6px;
  font-size: 13px; font-weight: 500; color: var(--text-muted);
  transition: all .15s; text-decoration: none;
}
.nav-link:hover, .nav-link.router-link-exact-active {
  background: var(--primary-light); color: var(--primary);
}
.user-area {
  margin-left: auto;
  display: flex; align-items: center; gap: 10px;
}
.avatar-wrap { position: relative; flex-shrink: 0; }
.avatar {
  width: 30px; height: 30px; border-radius: 50%;
  object-fit: cover; border: 2px solid var(--border); display: block;
}
.avatar-fallback {
  width: 30px; height: 30px; border-radius: 50%;
  background: var(--primary); color: #fff;
  font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  border: 2px solid var(--border);
}
.user-name { font-size: 13px; font-weight: 500; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>
